import { useCurrentStateAndParams } from "@uirouter/react";

import { useChannelData } from "../../../../components/common/helpers";
import { isPeriodOverPeriod } from "../utils";

const sourceRenameMap: Record<string, string> = {
    "Display Ads": "Display",
};

const renameTrafficSources = (data) => {
    if (Array.isArray(data)) {
        return data.map(renameTrafficSources);
    }
    if (data && typeof data === "object") {
        const renamed: any = {};
        for (const [key, value] of Object.entries(data)) {
            const newKey = sourceRenameMap[key] || key;
            renamed[newKey] = renameTrafficSources(value);
        }
        return renamed;
    }
    return data;
};

const useBetaChannelTrafficData = ({ durationObject, isMTDActive, selectedGranularity }) => {
    const { params } = useCurrentStateAndParams();
    const { key, webSource, country, duration, isWWW } = params;

    const { data, isLoading, getExcelUrl } = useChannelData({
        params: { country, duration, isWWW, key, webSource, MMXBeta: true },
        durationObject,
        isMTDActive,
        granularity: selectedGranularity,
        isPeriodOverPeriod: isPeriodOverPeriod(),
        withExcel: true,
        isMmxBeta: true,
    });
    const transformedData = renameTrafficSources(data);
    return {
        data: transformedData,
        isLoading,
        getExcelUrl,
    };
};

export default useBetaChannelTrafficData;
